module.exports = __webpack_public_path__ + "img/success-logo-icon.765071b4.png";